import React, { useState, useEffect } from "react";
import AutoProgram from "../../Assets/icons/AutoProgram.svg";
import AutoAddress from "../../Assets/icons/AutoAddress.svg";
import System from "../../Assets/icons/System.svg";
import DeviceZone from "../../Assets/icons/DeviceZone.svg";
import Key from "../../Assets/icons/Key.svg";
import Time from "../../Assets/icons/Time.svg";
import Map from "../../Assets/icons/Map.svg";

const ConfigureFrame = ({ setCurrentFrame, panelVersion }) => {
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
      const updateTime = () => {
        const now = new Date();
        let formattedTime = now.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }).replace(/,/g, ""); // Remove comma between date and time
  
        formattedTime = formattedTime.replace(/(\d{4})\//, "$1 "); // Remove '/' after year
        setCurrentTime(formattedTime);
      };
  
      updateTime();
      const interval = setInterval(updateTime, 1000);
      return () => clearInterval(interval);
    }, []);


  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ fontSize: 40, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ textAlign: "left", flex: 1 }}>Configure</span>
        <span style={{ textAlign: "right", flex: 1 }}>{currentTime}</span>
      </div>
      <hr style={{ width: "100%", border: "1px solid black", margin: "5px 0" }} />
      {panelVersion === "2.7.F9" && <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "1px", width: "98%", height: "36%", textAlign: "center", margin: "0 0 1px 0" }}>
        {[{ icon: AutoProgram, text: "Auto Progr.", disabled: true },
        { icon: AutoAddress, text: "Auto Addr.", disabled: true },
        { icon: Map, text: "Auto Map", disabled: true },
        { icon: System, text: "System", onClick: () => setCurrentFrame("system") },].map((btn, index) => (
          <button key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px", fontSize: "30px", width: "100%", background: btn.disabled ? "#ccc" : "none", borderRadius: "5px", cursor: btn.disabled ? "not-allowed" : "pointer", opacity: btn.disabled ? 0.5 : 1, }}
            onClick={btn.disabled ? undefined : btn.onClick}
            disabled={btn.disabled}
          >
            <img src={btn.icon} alt={btn.text} style={{ width: "70px", height: "70px", marginBottom: "10px" }} />
            {btn.text}
          </button>
        ))}
      </div>}
      {panelVersion === "2.0.F7" && <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1px", width: "98%", height: "36%", textAlign: "center" }}>
        {[{ icon: AutoProgram, text: "Auto Progr.", disabled: true },
        { icon: AutoAddress, text: "Auto Addr.", disabled: true },
        { icon: System, text: "System", onClick: () => setCurrentFrame("system") },].map((btn, index) => (
          <button key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px", fontSize: "30px", width: "100%", background: btn.disabled ? "#ccc" : "none", borderRadius: "5px", cursor: btn.disabled ? "not-allowed" : "pointer", opacity: btn.disabled ? 0.5 : 1, }}
            onClick={btn.disabled ? undefined : btn.onClick}
            disabled={btn.disabled}
          >
            <img src={btn.icon} alt={btn.text} style={{ width: "70px", height: "70px", marginBottom: "10px" }} />
            {btn.text}
          </button>
        ))}
      </div>}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1px", width: "98%", height: "36%", textAlign: "center" }}>
        {[{ icon: DeviceZone, text: "Device/Zone", onClick: () => setCurrentFrame("deviceZone") },
        { icon: Key, text: "Passwords", onClick: () => setCurrentFrame("passwords") },
        { icon: Time, text: "Date & Time", onClick: () => setCurrentFrame("clock") },].map((btn, index) => (
          <button key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px", fontSize: "30px", width: "100%", background: btn.disabled ? "#ccc" : "none", borderRadius: "5px", cursor: btn.disabled ? "not-allowed" : "pointer", opacity: btn.disabled ? 0.5 : 1, }}
            onClick={btn.disabled ? undefined : btn.onClick}
            disabled={btn.disabled}
          >
            <img src={btn.icon} alt={btn.text} style={{ width: "70px", height: "70px", marginBottom: "10px" }} />
            {btn.text}
          </button>
        ))}
      </div>
      <div style={{ display: "flex", width: "98%", justifyContent: "space-evenly", position: "absolute", bottom: "2%" }}>
        <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 40% 0 0", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("main")}>Logout</button>
          <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 0px", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("programming")}>Back</button>
        </div>
      </div>
    );
};

export default ConfigureFrame;
